import React from 'react'





export const Curriculum = () => {


  return (
    <div className='page'>
        <h1 className='heading'>Curriculum</h1>

        <h2>Experiencia Laboral</h2>
        <ul>
            <li>Empresa: Telares de Palo Grande</li>
            <li>Cargo: Pasante Taller de Electronica</li>
            <li>Desde: 27/03/12 hasta 27/0712</li>
        </ul>
        <ul>
            <li>Empresa: Ascensores Schindler de Venezuela S.A.</li>
            <li>Cargo: Instalador</li>
            <li>Desde: 18/08/13 hasta 18/12/18</li>
        </ul>

        <ul>
            <li>Empresa: Duplex S. A.</li>
            <li>Cargo: tecnico especialista en mantencion e instalacion de equipos de transporte vertical</li>
            <li>Desde: 08/01/19 hasta 17/09/19</li>
            
        </ul>

        <ul>
            <li>Empresa: ESAT</li>
            <li>Cargo: Tecnico de Mantenimiento y Reparaciones</li>
            <li>Desde: 08/01/19 hasta 08/2023</li>
        </ul>

        <ul>
            <li>Empresa: Servas Elevators</li>
            <li>Cargo: Tecnico de Servicio</li>
            <li>Desde: 12/12/23 hasta 09/10/24</li>
        </ul>

        <ul>
            <li>Empresa: Rojas Cohen Ingenieria en Ascensores</li>
            <li>Cargo: Supervisor de Reparaciones y Mantenimiento</li>
            <li>Desde: 09/10/24 hasta la fecha</li>
        </ul>

        <h2>Educacion</h2>
        <table class="default">
            <tr>
                <td>Universitario:</td>
                <td>UNEFA 2013 Ingenieria Electronica</td>
            </tr>
            <tr>
                <td>Diversificado:</td>
                <td>Bachiller en Ciencias 2006</td>
            </tr>
            <tr>
                <td>Ingles Intermedio:</td>
                <td>Instituto Loscher Ebbinghaus</td>
            </tr>
        </table>

        <h2>Cursos y Talleres realizados</h2>
        <ul>
            <li>Básico de Ascensores 07/05/13 - 16/08/13</li>
            <li>Reconocimiento a la excelencia 16/08/2013</li>
            <li>Certificación Amarilla 01/11/2013</li>
            <li>Educación Para el Trabajo 13 y 14 de Agosto 2013</li>
            <li>Curso Instalación y Funcionamiento de Ascensor 3300 (Lugar: Colombia)</li>
            <li>Trabajo en Alturas: 24/01/2014</li>
            <li>Paracaídas y Limitadores de Velocidad 28 y 29 de Mayo del 2015</li>
            <li>Frenos con Electroimán Para Maquinas con Reductor</li>
            <li>Análisis de Riesgo Bloqueo y Etiquetado 02/10/2015</li>
            <li>Uso e Inspección de Andamios 25/09/2015</li>
            <li>Modulo: Seguridad (Teorico y Practico) Z07c 25/07/201</li>
            <li>Curso Teórico Practico de Prevención y Mitigación en Caso de Caídas en Pozos de Ascensores 24/07/2014</li>
            <li>Taller de Primeros Auxilios Nivel Básico 23/10/2015</li>
            <li>Mantentenedor Preventivo de Ascensores y Montacargas Chile Valora 23/12/25</li>
            <li>Mantentenedor Correctivo Mecanico de Ascensores y Montacargas Chile Valora 23/12/25</li>
            <li>Mantentenedor Correctivo Electrico de Ascensores y Montacargas Chile Valora 23/12/25</li>
            <li><a href='./pdf' target='blank'>Ver Certificados</a></li>

        </ul>

        <h2>Proyectos Personales</h2>
        <ul>
            <li>Desarrollo Web HTML, CSS, React: Lenguales de programacion con las que he realizado este portafolio</li>
            <li>Desarrollo de Aplicaciones Moviles: Aprender las herramientas para diseñar aplicaciones que ayuden a mejorar las soluciones de averias en las distintas tecnologias de Ascensores</li>
            <li>Diseño de circuitos electronicos con controlador arduino orientados o los ascensores</li>
            <li>Mejorar mi nivel de Ingles</li>
        </ul>

        <h2>Destrezas y Actitudes</h2>
        <ul>
            <li>Buenas relaciones Interpersonales.</li>
            <li>Adaptación Rápida</li>
            <li>Iniciativa y creatividad para el trabajo.</li>
            <li>Pro-actividad y con buena disposición para colaborar.</li>
            <li>Buena presencia</li>
            <li>Responsabilidad, Disciplina, Discreción, Amabilidad</li>
            <li>Cortesía, Confianza, orden y pulcritud.</li>
        </ul>
    </div>
  )
}

 